import {
  AbsenceCategory,
  AbsenceFilters,
  AbsenceSortDirection,
  AbsenceSortField,
} from "@myapp/contract";
import { toOptionalString } from "../../../../shared/lib/optionalParsers";

export interface TimeManagementFiltersForm {
  technicianName: string;
  category: AbsenceCategory | null;
  dateFrom: string;
  dateTo: string;
  sortField: AbsenceSortField;
  sortDirection: AbsenceSortDirection;
}

export const INITIAL_TIME_MANAGEMENT_FILTERS: TimeManagementFiltersForm = {
  technicianName: "",
  category: null,
  dateFrom: "",
  dateTo: "",
  sortField: "startsAt",
  sortDirection: "DESC",
};

export const mapFiltersFormToApi = (
  filters: TimeManagementFiltersForm,
  limit: number,
): AbsenceFilters => ({
  limit,
  technicianName: toOptionalString(filters.technicianName),
  category: filters.category ?? undefined,
  dateFrom: toOptionalString(filters.dateFrom),
  dateTo: toOptionalString(filters.dateTo),
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
});
